import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Weet u zeker dat u live bestellingen wilt uitschakelen?',
    enable: 'Weet u zeker dat u live bestellingen wilt inschakelen?',
  },
  form: {
    is_google_business_available: {
      label: 'Google Business beschikbaar',
    },
    is_smart_pricing_configured: {
      label: 'Goedkopere prijzen dan Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Promotiefolder verstuurd',
    },
    is_menu_fully_configured: {
      label: 'Alle menu-items beschikbaar',
    },
    has_offers_on_competitor_platforms: {
      label: 'Heeft het restaurant aanbiedingen actief op Wolt, Uber, Lieferando (behalve gratis bezorgaanbod)?',
    },
    is_instagram_story_shared: {
      label: 'Instagram story gedeeld met eigenaar',
    },
    is_order_system_connected_to_website: {
      label: 'Foodamigos-website gekoppeld OF eigen restaurantwebsite met Online bestellen-knop toegevoegd',
    },
    google_business_connected_by: {
      label: 'Hoe hebben we toegang gekregen tot Google Business Profile?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Salesmanager heeft google@foodamigos.io uitgenodigd',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Salesmanager heeft het eerste verzoek zelf verzonden via de telefoon van de eigenaar',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Onboardingmanager heeft Google Business Profile aangevraagd (SM heeft niet uitgenodigd en geen toegang aangevraagd)',
      },
    },
  },
  labels: {
    successful_launch:
      'Voor een succesvolle lancering, bekijk en behandel de volgende openstaande punten. Verificatie \n' +
      'van deze informatie helpt mogelijke problemen te voorkomen zodra het restaurant live is.',
    check_errors: 'Controleer de fouten voor een goede lancering van het restaurant.',
    checkbox_confirmation: 'Ik bevestig dat ik de fouten heb bekeken en instem met de activering van dit restaurant.',
  },
  buttons: {
    check_error: 'Fout controleren',
    confirm_and_activate: 'Bevestigen en activeren',
    cancel: 'Annuleren',
    yes: 'Ja',
    no: 'Nee',
  },
  errors: {
    name: {
      title: 'Geen Arabische, Chinese e.d. tekens in winkelnaam',
      description: 'Winkelnaam bevat niet-Engelse (Latijnse) tekens',
    },
    logo_url: {
      title: 'Logo',
      description: 'Logo is geüpload naar de webshop',
    },
    pictures: {
      title: 'Galerijafbeelding',
      description: '≥ 1 galerijafbeelding beschikbaar in webshop',
    },
    menu_uploaded: {
      title: 'Menu geüpload',
      description: '≥ 1 menu beschikbaar',
    },
    opening_hours: {
      title: 'Openingstijden',
      description: '≥ 1 openingstijd toegevoegd',
    },
    address: {
      title: 'Restaurantadres',
      description: 'Straat, stad, postcode ingevoerd',
    },
    upsell_items: {
      title: 'Upsell-items',
      description: '≥ 3 upsell-items geselecteerd',
    },
    master_promo_code: {
      title: 'Hoofdpromotiecode',
      description: 'Hoofdpromotiecode beschikbaar',
    },
    flyers_ordered: {
      title: 'Folders besteld',
      description: '≥ 1 folderpakket besteld',
    },
    test_orders: {
      title: 'Testbestelling verzonden',
      description: '≥ 1 testbestelling geplaatst',
    },
    stripe_billing: {
      title: 'Stripe-account',
      description: 'Stripe-account gekoppeld',
    },
    payments_configured: {
      title: 'Betalingen geconfigureerd',
      description: 'De partner heeft een betaalprovider gekoppeld — vereist vóór livegang',
    },
    adyen_merchant_account: {
      title: 'Adyen-handelaarsaccount',
      description:
        'Een actief handelaarsaccount voor het land van dit restaurant — vereist voor binnenlandse kaarttarieven',
    },
    payment_rail_covers_country: {
      title: 'Betaalkanaal dekt het land',
      description: 'De betaalaccounts van de partner kunnen het land van dit restaurant verwerken',
    },
    identity: {
      title: 'Restaurantidentiteit',
      description: 'Restauranttype en keuken zijn ingesteld',
    },
    storefront: {
      title: 'Storefront aangemaakt en domein gekoppeld',
      description: 'Alleen als het restaurant onze website wil gebruiken',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business gekoppeld',
    },
    billing_payment_method: {
      title: 'Betaalmethode',
      description: 'Voeg een betaalmethode toe zodat FoodAmigos dit restaurant maandelijks kan factureren.',
    },
    billing_license: {
      title: 'Licentie',
      description: 'Dit restaurant heeft een Partner Plan nodig voordat het live kan gaan.',
    },
    business_name: {
      title: 'Bedrijfs- / restaurantnaam',
      description: 'De naam in de gebruiksvoorwaarden en het privacybeleid is opgeslagen',
    },
    payment_method: {
      title: 'Contant of online betalingen',
      description: 'Contant bij afhalen of bezorgen staat aan, of online betalingen zijn geverifieerd',
    },
    stripe_processing_fee: {
      title: 'Verwerkingskosten',
      description: 'De partner heeft de Stripe-verwerkingskosten ingesteld of een marge van 0% bevestigd',
    },
  },
};
